export default __webpack_public_path__ + "static/media/elephant.7cbedf22.png";